/**
 * @generated SignedSource<<5f6f9ebe4e63fab97d16162b6a0112a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCardView_creditCard$data = {
  readonly cardExpiryMonth: string | null;
  readonly cardExpiryYear: string | null;
  readonly cardHolderName: string | null;
  readonly cardLogo: string | null;
  readonly cardType: string | null;
  readonly formattedTextMaskedCardNumber: string | null;
  readonly isExpired: boolean | null;
  readonly " $fragmentType": "CheckoutCreditCardView_creditCard";
};
export type CheckoutCreditCardView_creditCard$key = {
  readonly " $data"?: CheckoutCreditCardView_creditCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardView_creditCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCardView_creditCard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardLogo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardHolderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardExpiryMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardExpiryYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedTextMaskedCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExpired",
      "storageKey": null
    }
  ],
  "type": "CreditCard",
  "abstractKey": null
};

(node as any).hash = "4043ce113bd007d02486da004080b3c8";

export default node;
